import { useState } from "react";
import { trpc } from "../../../lib/api/trpc";

interface OnboardingResult {
  success: boolean;
  error?: string;
}

/**
 * Hook for managing onboarding emails (send and resend)
 */
export const useOnboarding = () => {
  const [isSending, setIsSending] = useState(false);

  // @ts-ignore - Type checking for trpc.useContext
  const utils = trpc.useContext();

  // Send onboarding email mutation
  // @ts-ignore - Type checking for trpc.user property
  const sendOnboardingEmailMutation = trpc.user.sendOnboardingEmail.useMutation(
    {
      onSuccess: () => {
        // @ts-ignore - Type checking for utils.user property
        utils.user.getUsers.invalidate();
        // @ts-ignore - Type checking for utils.user property
        utils.user.getUserById.invalidate();
      },
    },
  );

  /**
   * Send or resend onboarding email to a single user
   */
  const sendOnboardingEmail = async (
    userId: string,
  ): Promise<OnboardingResult> => {
    try {
      setIsSending(true);
      await sendOnboardingEmailMutation.mutateAsync({ userId });
      return { success: true };
    } catch (error: any) {
      const errorMessage = error?.message || "Failed to send onboarding email";
      return { success: false, error: errorMessage };
    } finally {
      setIsSending(false);
    }
  };

  return {
    sendOnboardingEmail,
    isSending,
  };
};
